/* eslint-disable @ngrx/prefer-effect-callback-in-block-statement */
import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';

import { ProductDetailService } from '@cdba/detail/service/detail.service';
import { Drawing, ReferenceTypeIdentifier } from '@cdba/shared/models';

import {
  loadDrawings,
  loadDrawingsFailure,
  loadDrawingsSuccess,
  selectReferenceTypeIdentifier,
} from '../../../actions';
import { getSelectedReferenceTypeIdentifier } from '../../../selectors';

@Injectable()
export class DrawingsEffects {
  private readonly actions$ = inject(Actions);
  private readonly productDetailService = inject(ProductDetailService);
  private readonly store = inject(Store);

  triggerDataLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(selectReferenceTypeIdentifier),
      map(() => loadDrawings())
    )
  );

  loadDrawings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDrawings),
      concatLatestFrom(() =>
        this.store.select(getSelectedReferenceTypeIdentifier)
      ),
      map(([_action, refTypeIdentifier]) => refTypeIdentifier),
      mergeMap(({ materialNumber, plant }: ReferenceTypeIdentifier) =>
        this.productDetailService.getDrawings(materialNumber, plant).pipe(
          map((items: Drawing[]) => loadDrawingsSuccess({ items })),
          catchError((error: HttpErrorResponse) =>
            of(
              loadDrawingsFailure({
                errorMessage: error.error.detail || error.message,
                statusCode: error.status,
              })
            )
          )
        )
      )
    )
  );
}
